module.exports = __webpack_public_path__ + "static/z-11-obraz-697911fdde1d30dd7e12d302ab3af459.png";